import { hasCapability, type User } from "../base";

export const workflow = {
  modifyDraft: (user: User) => hasCapability(user, "workflow.modifyDraft"),
  read: (user: User) => hasCapability(user, "workflow.read"),
  publish: (user: User) => hasCapability(user, "workflow.publish"),
  migrate: (user: User) => hasCapability(user, "workflow.migrate"),
};
